import http from "./httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/transactions/";
const url = apiUrl + endPoint;

export async function getTransactions(pageNumber, pageSize, searchQuery) {
  return await http.get(url + pageNumber + "/" + pageSize + "?searchQuery=" + searchQuery);
}

export async function getTransactionsCount(searchQuery) {
  return await http.get(url + "count/?searchQuery=" + searchQuery);
}

export async function getTransactionById(transactionId) {
  return await http.get(url + transactionId);
}

export async function changeStatus(transactionId, status) {
  return await http.put(url + "status/" + transactionId, { status });
}

export async function addTransaction(transaction) {
  return await http.post(url, transaction);
}

export async function verifyOnlinePayment(onlineTransactionId, transaction) {
  return await http.post(url + "verify/" + onlineTransactionId, transaction);
}

export async function getMyAccountBalance() {
  return await http.get(url + "myAccountBalance/");
}

export async function getCustomerAccountBalance(customerId) {
  return await http.get(url + "accountBalance/" + customerId);
}

export async function getCustomerTransactions(customerId) {
  return await http.get(url + "customer/" + customerId);
}

export async function getMyTransactions() {
  return await http.get(url + "mine");
}
